import { gql, useQuery } from '@apollo/client';
import { DateRangeValue } from '../../../shared/types';

const gqlQueryFilter = gql`
    query overviewTripState {
        CITRIN_MGT_overviewTripState @client
    }
`;
const typeName = 'CITRIN_MGT_overviewTripState';

export type OverviewState = {
    quickStatusFilter?: 'Done' | 'Running' | 'Suspended';
    selectedDateRange?: DateRangeValue;
    search?: string;
    page?: number;
};

const initialState: OverviewState = {
    quickStatusFilter: 'Done',
    selectedDateRange: {
        fromDate: undefined,
        toDate: undefined,
    },
    search: '',
    page: 1,
};

export const useOverviewLinkState = (): [OverviewState, (newState: OverviewState) => void] => {
    const { data, client } = useQuery(gqlQueryFilter, { fetchPolicy: 'cache-first' });
    const setState = (newState: OverviewState) => {
        client.writeQuery({
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewTripState: {
                    value: newState,
                    __typename: typeName,
                },
            },
        });
    };
    return [data?.CITRIN_MGT_overviewTripState?.value ?? initialState, setState];
};

export default {
    defaults: [
        {
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewTripState: {
                    value: initialState,
                    __typename: 'CITRIN_MGT_overviewTripState',
                },
            },
        },
    ],
};
